import PensionsInfoFlereOplysingerView from './PensionsInfoFlereOplysingerView';

export default PensionsInfoFlereOplysingerView;
